import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, SecurityContext, AfterViewInit } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import {
  NewsletterViewModel, NewsletterInfo, NewsletterPromo, NewsletterSectionResponseModel, NewsletterEditViewModelV2
} from '../../../models/catalogue-view.model';
import { ApiResponse } from '../../../models/api-response.model';
import { Subscription } from '../../../../../node_modules/rxjs';
import { NewsletterDeleteSectionComponent } from '../../../popup-collection/newsletter-delete-section/newsletter-delete-section.component';
import { NewsletterPromoNameComponent } from '../../../popup-collection/newsletter-promo-name/newsletter-promo-name.component';
import { NewsletterPromoAreaComponent } from '../../../popup-collection/newsletter-promo-area/newsletter-promo-area.component';
import { NewsletterPromoImageComponent } from '../../../popup-collection/newsletter-promo-image/newsletter-promo-image.component';
import { MatDialog } from '@angular/material/dialog';
import { NgProgressService } from '../../../services/ngProgress.service';
import { NewsletterService } from '../../../services/newsletter.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

declare var jquery: any;
declare var $: any;
declare var imageCompression: any;

@Component({
  selector: 'app-newsletter-promo-v2',
  templateUrl: './newsletter-promo-v2.component.html',
  styleUrls: ['./newsletter-promo-v2.component.css']
})
export class NewsletterPromoV2Component implements OnInit, AfterViewInit {
  newsletterEditSubscription: Subscription;
  getNewsletterViewSubscription: Subscription;
  getNewsletterInfoSubscription: Subscription;
  colorSubscription: Subscription;

  createLoading = {
    section: false,
    promo: false,
  }

  titleColor: string;
  newletterToEditId: string = "";
  addingTitle: string = "";
  newsletterView: NewsletterViewModel;

  newsletterInfoPromo: NewsletterPromo[] = [];

  removePromoModel: NewsletterPromo;
  removePromoOverlay = false;

  editNewsletterTitle = false;

  editSection = false;

  dragDropModel: NewsletterPromo;
  targetSectionId: string;
  targetPromo: NewsletterPromo;
  targetPos: string;
  dragIndex: number;
  targetIndex: number;
  moveIndex: number;
  movePromo: NewsletterPromo;
  movePos: string;

  // edit properties
  editPromoContent = false;
  editPromoArea = false;
  editPromoImage = false;
  nl_content: string;
  nl_area: string;
  editAreaPromoModel: NewsletterPromo;
  editContentPromoModel: NewsletterPromo;
  editImagePromoModel: NewsletterPromo;
  editAreaType: string;
  editContentType: string;
  editImageType: string;
  editAreaIndex: number;
  imageUrl: string;
  formData = new FormData();
  newsletterInfo: NewsletterInfo;
  // newsletterEditViewModel: NewsletterEditViewModel;
  @Input() sendNewIdToPromo: string;
  @Input() newsletterEditViewModel: NewsletterEditViewModelV2;
  @Output() editPromoEvent = new EventEmitter<boolean>();

  constructor(
    private newsletterService: NewsletterService,
    public ngProgress: NgProgressService,
    private commonService: CommonService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    
    this.ngProgress.start();

    this.getNewsletterInfoSubscription = this.newsletterService.getNewsletterPromos(this.sendNewIdToPromo)
      .subscribe((res: NewsletterPromo[]) => {
        this.newsletterInfoPromo = this.decodePromo(res);
        for (var i = 0; i < this.newsletterInfoPromo.length; i++) {
          //'data:image/png;base64,' + 
          this.newsletterInfoPromo[i].l_image = this.newsletterInfoPromo[i].l_image ? this.sanitizer.sanitize(SecurityContext.URL, this.newsletterInfoPromo[i].l_image) : null;
          this.newsletterInfoPromo[i].r_image = this.newsletterInfoPromo[i].r_image ? this.sanitizer.sanitize(SecurityContext.URL, this.newsletterInfoPromo[i].r_image) : null;
        }
        this.ngProgress.done();
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
    });

    this.colorSubscription = this.newsletterService.currentColorWatch.subscribe((res: string) => {
      this.titleColor = res;
    });
    
  }

  ngAfterViewInit(): void {
    var dynamicScripts = ["https://cdn.jsdelivr.net/npm/browser-image-compression@1.0.14/dist/browser-image-compression.js"];

    for (var i = 0; i < dynamicScripts.length; i++) {
      let node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

  toHTML(input: any): any {
    return new DOMParser().parseFromString(input, 'text/html').documentElement.innerHTML;
  }

  sendeditSection(): void {
    this.editSection = true;
    this.editPromoEvent.emit(this.editSection);
    this.editSection = false;
  }

  deletePromo(promo: NewsletterPromo): void {
    const dialogRef = this.dialog.open(NewsletterDeleteSectionComponent, {
      width: '500px',
      panelClass: 'mat-dialog-wrapper',
      data: { type: "promo" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();
        this.newletterToEditId = promo.section_id;
        this.addingTitle = "Deleting Promo...";
        this.newsletterService.deleteNewsletterPromo(this.sendNewIdToPromo, promo.section_id)
          .subscribe((res: ApiResponse) => {
            this.newsletterService.getNewsletterPromos(this.sendNewIdToPromo).subscribe((res1: NewsletterPromo[]) => {
              this.newsletterInfoPromo = this.decodePromo(res1);
              this.ngProgress.done();
            },
              (error: any) => {
                console.error(error);
                this.newletterToEditId = "";
                this.addingTitle = "";
                this.ngProgress.done();
              });
          },
            (error: any) => {
              console.error(error);
              this.newletterToEditId = "";
              this.addingTitle = "";
              this.ngProgress.done();
            });
      }
    });
  }

  moveUp(promo: NewsletterPromo): void {
    
    this.moveIndex = this.newsletterInfoPromo.findIndex(x => x.section_id === promo.section_id);
    if (this.moveIndex !== 0) {
      const promoBup = [ ...this.newsletterInfoPromo ];
      const moveData = { ...this.newsletterInfoPromo[this.moveIndex] };
      const targetData = { ...this.newsletterInfoPromo[this.moveIndex-1] };
      this.newsletterInfoPromo[this.moveIndex] = { ...targetData };
      this.newsletterInfoPromo[this.moveIndex].section_pos = moveData.section_pos;
      this.newsletterInfoPromo[this.moveIndex-1] = { ...moveData };
      this.newsletterInfoPromo[this.moveIndex-1].section_pos = targetData.section_pos;
      this.newsletterService.savePromo(this.newsletterInfoPromo[this.moveIndex - 1]).subscribe((res:
        NewsletterSectionResponseModel) => {
          if (res && res.status) {
            this.commonService.implementToast("Successfully switch Promo", "Success");
            this.ngProgress.done();
          }
        }),
        (error: any) => {
          console.error(error);
          this.newsletterInfoPromo = promoBup;
          this.ngProgress.done();
        };
    }
  }

  moveDown(promo: NewsletterPromo): void {

    this.moveIndex = this.newsletterInfoPromo.findIndex(x => x.section_id === promo.section_id);
    if (this.moveIndex !== this.newsletterInfoPromo.length - 1) {
      const promoBup = [ ...this.newsletterInfoPromo ];
      const moveData = { ...this.newsletterInfoPromo[this.moveIndex] };
      const targetData = { ...this.newsletterInfoPromo[this.moveIndex+1] };
      this.newsletterInfoPromo[this.moveIndex] = { ...targetData };
      this.newsletterInfoPromo[this.moveIndex].section_pos = moveData.section_pos;
      this.newsletterInfoPromo[this.moveIndex+1] = { ...moveData };
      this.newsletterInfoPromo[this.moveIndex+1].section_pos = targetData.section_pos;
      this.newsletterService.savePromo(this.newsletterInfoPromo[this.moveIndex + 1]).subscribe((res:
        NewsletterSectionResponseModel) => {
          if (res && res.status) {
            this.commonService.implementToast("Successfully switch Promo", "Success");
            this.ngProgress.done();
          }
        }),
        (error: any) => {
          console.error(error);
          this.newsletterInfoPromo = promoBup;
          this.ngProgress.done();
        };
    }
  }

  addPromo(): void {

    this.ngProgress.start();
    this.createLoading.promo = true;
    this.newsletterService.addPromo(this.sendNewIdToPromo).subscribe((res: NewsletterSectionResponseModel) => {
      if (res.status) {
        this.newsletterService.getNewsletterInfo(this.sendNewIdToPromo).subscribe((res1: NewsletterInfo) => {
          this.newsletterInfoPromo = res1.promoList;
          this.createLoading.promo = false;
          this.ngProgress.done();
        },
          (error: any) => {
            console.error(error);
            this.ngProgress.done();
          });
      } else {
        this.commonService.implementToast(res.content, 'Error');
        this.createLoading.promo = false;
        // this.commonService.showError('#cmsNewPromo', res.content, 'bottom');
        this.ngProgress.done();
      }
    },
      (error: any) => {
        console.error(error);
        this.ngProgress.done();
      });
  }

  addSection(): void {

    this.ngProgress.start();
    this.createLoading.section = true;
    this.newsletterService.addSection(this.sendNewIdToPromo)
      .subscribe((res: NewsletterSectionResponseModel) => {
        this.newsletterService.monitorSectionIdChange(res.section_id);
        this.createLoading.section = false;
        this.ngProgress.done();
      },
        (error: any) => {
          console.error(error);
          this.createLoading.section = false;
          this.ngProgress.done();
        });

  }

  onDropCDKPromo(event: CdkDragDrop<string[]>): void {

    if(event.previousIndex != event.currentIndex) {
      this.ngProgress.start();

      const promoBup = [ ...this.newsletterInfoPromo ];
      const dragData = { ...this.newsletterInfoPromo[event.previousIndex] };
      const targetData = { ...this.newsletterInfoPromo[event.currentIndex] };

      this.newsletterInfoPromo[event.previousIndex] = { ...targetData };
      this.newsletterInfoPromo[event.previousIndex].section_pos = dragData.section_pos;
      this.newsletterInfoPromo[event.currentIndex] = { ...dragData };
      this.newsletterInfoPromo[event.currentIndex].section_pos = targetData.section_pos;
      
      this.newsletterService.savePromo(this.newsletterInfoPromo[event.currentIndex]).subscribe((res: NewsletterSectionResponseModel) => {
        if (res && res.status) {
          this.commonService.implementToast("Successfully switch Promo", "Success");
          this.ngProgress.done();
        }
      }),
        (error: any) => {
          console.error(error);
          this.newsletterInfoPromo = promoBup;
          this.ngProgress.done();
        }
    }
  }

  savePromoArea(stockCodes: string, promo: NewsletterPromo, editAreaType: string, editAreaIndex: number): void {

    const dialogRef = this.dialog.open(NewsletterPromoAreaComponent, {
      width: '500px',
      panelClass: 'mat-dialog-wrapper',
      data: { stockCodes: stockCodes }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();
        this.newletterToEditId = promo.section_id;
        this.addingTitle = "Saving promo area...";
        this.editAreaPromoModel = promo;
        if (editAreaType === 'l_stock_code') {
          this.editAreaPromoModel.l_stock_code = result.stockCodes.split(',')[0].trim();
        } else if (editAreaType === 'r_stock_code') {
          this.editAreaPromoModel.r_stock_code = result.stockCodes.split(',')[0].trim();
        }

        this.editAreaPromoModel.section_pos = '';

        this.newsletterService.savePromo(this.editAreaPromoModel)
          .subscribe((res: NewsletterSectionResponseModel) => {
            this.newsletterService.getNewsletterPromos(this.sendNewIdToPromo).subscribe((res1: NewsletterPromo[]) => {
              this.newsletterInfoPromo = this.decodePromo(res1);
              if (editAreaType === 'l_stock_code') {
                if (!this.newsletterInfoPromo[editAreaIndex].l_promo_price) {
                  this.newsletterInfoPromo[editAreaIndex].l_stock_code = 'Invalid StockCode';
                }
              } else if (editAreaType === 'r_stock_code') {
                if (!this.newsletterInfoPromo[editAreaIndex].r_promo_price) {
                  this.newsletterInfoPromo[editAreaIndex].r_stock_code = 'Invalid StockCode';
                }
              }
              this.newletterToEditId = "";
              this.addingTitle = "";
              this.ngProgress.done();
            },
              (error: any) => {
                console.error(error);
                this.newletterToEditId = "";
                this.addingTitle = "";
                this.ngProgress.done();
              });
          },
            (error: any) => {
              console.error(error);
              this.newletterToEditId = "";
              this.addingTitle = "";
              this.ngProgress.done();
            });
      }
    });
  }


  savePromoContent(promoContent: string, promo: NewsletterPromo, type: string): void {
    this.editContentPromoModel = promo;
    this.editContentType = type;
    if (type.split('_')[1] === 'header' && !promoContent) {
      this.nl_content = 'Promotion Name';
    } else if (type.split('_')[1] === 'promo' && !promoContent) {
      this.nl_content = 'Heading';
    } else if (type.split('_')[1] === 'description' && !promoContent) {
      this.nl_content = 'Description';
    } else {
      this.nl_content = promoContent;
    }
    if (type.split('_')[1] === 'header' || type.split('_')[1] === 'promo') {
      const dialogRef = this.dialog.open(NewsletterPromoNameComponent, {
        width: '500px',
        panelClass: 'mat-dialog-wrapper',
        data: { nl_content: this.nl_content, type: type.split('_')[1] }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.ngProgress.start();
          if (type.split('_')[1] === 'header') {
            this.addingTitle = 'Saving Promo Name...';
          } else if (type.split('_')[1] === 'promo') {
            this.addingTitle = 'Saving Promo Heading...';
          }
          this.newletterToEditId = promo.section_id;
          this.editContentPromoModel.section_pos = '';
          this.commonService.set(this.editContentPromoModel, [this.editContentType], result.nl_content);
          this.newsletterService.savePromo(this.editContentPromoModel).subscribe((res: NewsletterSectionResponseModel) => {
            this.newsletterService.getNewsletterPromos(this.sendNewIdToPromo).subscribe((res1: NewsletterPromo[]) => {
              this.newsletterInfoPromo = this.decodePromo(res1);
              this.newletterToEditId = "";
              this.addingTitle = "";
              this.ngProgress.done();
            },
              (error: any) => {
                console.error(error);
                this.newletterToEditId = "";
                this.addingTitle = "";
                this.ngProgress.done();
              });
          },
            (error: any) => {
              console.error(error);
              this.newletterToEditId = "";
              this.addingTitle = "";
              this.ngProgress.done();
            });
        }
      });
    } else {
      this.ngProgress.start();
      if (type.split('_')[1] === 'description') {
        this.addingTitle = 'Saving Promo Description...';
      }
      this.newletterToEditId = promo.section_id;
      this.editContentPromoModel.section_pos = '';
      this.commonService.set(this.editContentPromoModel, [this.editContentType], promoContent);
      this.newsletterService.savePromo(this.editContentPromoModel).subscribe((res: NewsletterSectionResponseModel) => {
        this.newsletterService.getNewsletterPromos(this.sendNewIdToPromo).subscribe((res1: NewsletterPromo[]) => {
          this.newsletterInfoPromo = this.decodePromo(res1);
          this.newletterToEditId = "";
          this.addingTitle = "";
          this.ngProgress.done();
        },
          (error: any) => {
            console.error(error);
            this.newletterToEditId = "";
            this.addingTitle = "";
            this.ngProgress.done();
          });
      },
        (error: any) => {
          console.error(error);
          this.newletterToEditId = "";
          this.addingTitle = "";
          this.ngProgress.done();
        });
    }
  }

  savePromoImage(promo: NewsletterPromo, editImageType: string): void {

    const dialogRef = this.dialog.open(NewsletterPromoImageComponent, {
      width: '500px',
      panelClass: 'mat-dialog-wrapper',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();
        this.addingTitle = "Saving Promo Image...";
        this.newletterToEditId = promo.section_id;
        var scaledFile;
        // Load the image
        var reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.resizeImage(image, image.naturalWidth, image.naturalHeight).toBlob((blob) => {
              scaledFile = new File([blob], result.name, {type: 'image/png'});
              this.formData.append(result.name, scaledFile);
              this.newsletterService.savePromoImage(promo.section_id, editImageType, this.formData)
                .subscribe((res: NewsletterSectionResponseModel) => {                  
                  this.newsletterService.getNewsletterPromos(this.sendNewIdToPromo).subscribe((res1: NewsletterPromo[]) => {
                    this.newsletterInfoPromo = this.decodePromo(res1);
                    this.newletterToEditId = "";
                    this.addingTitle = "";
                    this.ngProgress.done();
                  },
                    (error: any) => {
                      console.error(error);
                      this.newletterToEditId = "";
                      this.addingTitle = "";
                      this.ngProgress.done();
                    });
                  },
                  (error: any) => {
                    console.error(error);
                    this.newletterToEditId = "";
                    this.addingTitle = "";
                    this.ngProgress.done();
                  });
            }, 'image/png');
            
          };
          image.src = reader.result.toString();
        }     
        reader.readAsDataURL(result);
      }
    });
  }

  resizeImage(img: any, width: number, height: number) {

    const maxWidth = 200;

    const maxHeight = 200;

    let ratio;

    const canvas = document.createElement('canvas') as HTMLCanvasElement;

    var ctx = canvas.getContext('2d');

    if (width > maxWidth) {

      ratio = maxWidth / width;

      width = width * ratio;

      height = height * ratio;

    }

    // Check if current height is larger than max
    if (height > maxHeight) {

      ratio = maxHeight / height;

      width = width * ratio;

      height = height * ratio;

    }

    // set the canvas to be 200 x 200 regardless of image size
    canvas.width = maxWidth;

    canvas.height = maxHeight;

    // calculate the starting x and y position to make sure image is always centered
    var startWidth = width < maxWidth ? (maxWidth - width) / 2 : 0;
    var startHeight = height < maxHeight ? (maxHeight - height) / 2 : 0;

    ctx.drawImage(img, startWidth, startHeight, width, height);

    return canvas;

  }

  receiveEditSectionEvent($event): void {
    this.editPromoEvent.emit($event);
  }

  ngOnDestroy() {
    if (this.newsletterEditSubscription) {
      this.newsletterEditSubscription.unsubscribe();
    }
    if (this.getNewsletterInfoSubscription) {
      this.getNewsletterInfoSubscription.unsubscribe();
    }
    if (this.getNewsletterViewSubscription) {
      this.getNewsletterViewSubscription.unsubscribe();
    }
    if (this.colorSubscription) {
      this.colorSubscription.unsubscribe();
    }
  }
  
  htmlDecode(value) {
    return $("<textarea/>").html(value).text();
  }

  decodePromo(promos: NewsletterPromo[]): NewsletterPromo[] {
    for (var i = 0; i < promos.length; i++) {
      promos[i].l_promo_name = this.htmlDecode(promos[i].l_promo_name); 
      promos[i].l_header = this.htmlDecode(promos[i].l_header); 
      promos[i].l_description_01 = this.htmlDecode(promos[i].l_description_01); 
      promos[i].l_description_02 = this.htmlDecode(promos[i].l_description_02); 
      promos[i].l_description_03 = this.htmlDecode(promos[i].l_description_03); 
      promos[i].l_description_04 = this.htmlDecode(promos[i].l_description_04); 
      promos[i].l_description_05 = this.htmlDecode(promos[i].l_description_05); 
      promos[i].l_description_06 = this.htmlDecode(promos[i].l_description_06); 
      promos[i].r_promo_name = this.htmlDecode(promos[i].r_promo_name); 
      promos[i].r_header = this.htmlDecode(promos[i].r_header); 
      promos[i].r_description_01 = this.htmlDecode(promos[i].r_description_01); 
      promos[i].r_description_02 = this.htmlDecode(promos[i].r_description_02); 
      promos[i].r_description_03 = this.htmlDecode(promos[i].r_description_03); 
      promos[i].r_description_04 = this.htmlDecode(promos[i].r_description_04); 
      promos[i].r_description_05 = this.htmlDecode(promos[i].r_description_05); 
      promos[i].r_description_06 = this.htmlDecode(promos[i].r_description_06); 
    }
    return promos;
  }
}
